import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 md:p-10">
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
              Политика обработки публичных данных
            </h1>
            <p className="text-sm text-gray-500">
              Версия 1.1 от 17 января 2025 г.
            </p>
          </div>

          <div className="prose prose-sm md:prose-base max-w-none text-gray-700 space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Общие положения</h2>
              <p>
                Настоящая Политика обработки публичных данных (далее — «Политика») определяет порядок обработки 
                публичных данных в разработанном программном комплексе SkillGate (далее — «Сервис»), принадлежащем 
                Индивидуальному предпринимателю Вихляеву Сергею Николаевичу (далее — «Исполнитель»).
              </p>
              <p>
                Разработанный программный комплекс SkillGate предназначен для проведения скрининг-тестирования кандидатов 
                и <strong>не предназначен для обработки персональных данных</strong> в понимании Федерального закона 
                от 27.07.2006 № 152-ФЗ «О персональных данных».
              </p>
              <p>
                Настоящая Политика разработана в соответствии с законодательством Российской Федерации, включая:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных»;</li>
                <li>Федеральный закон от 27.07.2006 № 149-ФЗ «Об информации, информационных технологиях и о защите информации»;</li>
                <li>Гражданский кодекс Российской Федерации;</li>
                <li>Иные нормативные правовые акты Российской Федерации.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Сведения об Исполнителе</h2>
              <p>
                <strong>Индивидуальный предприниматель Вихляев Сергей Николаевич</strong>
              </p>
              <p>
                ИНН: 682004283576
              </p>
              <p>
                Адрес электронной почты: <a href="mailto:skillgate.pro@gmail.com" className="text-blue-600 hover:underline">skillgate.pro@gmail.com</a>
              </p>
              <p>
                Сайт: <a href="https://skillgate.pro" className="text-blue-600 hover:underline">https://skillgate.pro</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Хранение данных</h2>
              <p>
                Все данные, обрабатываемые разработанным программным комплексом SkillGate, хранятся на территории Российской Федерации. 
                Хостинг-провайдером является ООО «Регистратор доменных имен РЕГ.РУ» (далее — «reg.ru»).
              </p>
              <p>
                Исполнитель гарантирует, что все технические и организационные меры безопасности применяются 
                в соответствии с требованиями законодательства Российской Федерации.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Обрабатываемые данные</h2>
              <p>
                Сервис обрабатывает следующие категории публичных данных:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Электронные адреса пользователей Сервиса (для регистрации и связи);</li>
                <li>Названия компаний (для идентификации пользователей);</li>
                <li>Результаты тестирования кандидатов (в обезличенном виде);</li>
                <li>Базы вопросов для тестирования;</li>
                <li>Технические данные (IP-адреса, cookies, логи доступа).</li>
              </ul>
              <p>
                Сервис <strong>не обрабатывает персональные данные</strong> кандидатов, проходящих тестирование, 
                в том числе фамилии, имена, отчества, паспортные данные и иные данные, позволяющие идентифицировать 
                конкретное физическое лицо.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Цели обработки данных</h2>
              <p>
                Обработка данных осуществляется исключительно в следующих целях:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Предоставление доступа к функционалу Сервиса;</li>
                <li>Проведение скрининг-тестирования кандидатов;</li>
                <li>Формирование отчетов о результатах тестирования;</li>
                <li>Обеспечение безопасности и работоспособности Сервиса;</li>
                <li>Связь с пользователями по вопросам использования Сервиса.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Сроки хранения данных</h2>
              <p>
                Данные хранятся в течение срока, необходимого для достижения целей обработки, но не более 
                срока, установленного законодательством Российской Федерации.
              </p>
              <p>
                Пользователь вправе в любой момент запросить удаление своих данных, направив соответствующий 
                запрос на адрес электронной почты Исполнителя.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Меры защиты данных</h2>
              <p>
                Исполнитель применяет необходимые технические и организационные меры для защиты обрабатываемых 
                данных от неправомерного доступа, уничтожения, изменения, блокирования, копирования, предоставления, 
                распространения, а также от иных неправомерных действий.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Права пользователей</h2>
              <p>
                Пользователь имеет право:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Получать информацию об обработке своих данных;</li>
                <li>Требовать уточнения, блокирования или уничтожения своих данных;</li>
                <li>Отозвать согласие на обработку данных;</li>
                <li>Обжаловать действия или бездействие Исполнителя в уполномоченный орган по защите прав 
                субъектов персональных данных или в судебном порядке.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Изменение Политики</h2>
              <p>
                Исполнитель оставляет за собой право вносить изменения в настоящую Политику. Актуальная версия 
                Политики всегда доступна на странице <a href="https://skillgate.pro/privacy-policy" className="text-blue-600 hover:underline">https://skillgate.pro/privacy-policy</a>.
              </p>
              <p>
                При внесении существенных изменений Исполнитель уведомит пользователей путем размещения 
                соответствующего уведомления на Сайте или отправки уведомления на электронную почту.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Контактная информация</h2>
              <p>
                По всем вопросам, связанным с обработкой данных, пользователи могут обращаться к Исполнителю:
              </p>
              <p>
                Электронная почта: <a href="mailto:skillgate.pro@gmail.com" className="text-blue-600 hover:underline">skillgate.pro@gmail.com</a>
              </p>
            </section>
          </div>

          <div className="mt-10 pt-6 border-t border-gray-200 text-sm text-gray-500">
            <p>Дата последнего обновления: 17 января 2025 г.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;

